/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type Rubric from '@linc-technologies/linced-common/models/reports/rubric';

// Proto: reports.RubricElement.
export default class RubricElement extends Model {
  declare [Type]: 'reports/rubric-element';

  @belongsTo('reports/rubric', { async: true, inverse: null })
  declare rubricId: AsyncBelongsTo<Rubric>;

  @alias('rubricId')
  declare rubric: AsyncBelongsTo<Rubric>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare categoryId: string;

  @attr('string', { defaultValue: '' })
  declare templateCategoryId: string;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @array('string')
  declare subElements: StatefulArray<string>;
}
